import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../../test-utils/html-validate";

describe("autosuggest-item", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-autosuggest-item/>`);
        const el = await page.find("ux-autosuggest-item");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-autosuggest-item input="Lorem" text="Loremipsum" subline="Test" image="#" />`
        );
        const el = await page.find("ux-autosuggest-item");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot without image", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-autosuggest-item input="Lorem" text="Loremipsum" subline="Test" />`
        );
        const el = await page.find("ux-autosuggest-item");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html without image", async () => {
        await testValidHtml(
            `<ux-autosuggest-item input="Lorem" text="Loremipsum" subline="Test" />`
        );
    });

    it("should render valid html with image", async () => {
        await testValidHtml(
            `<ux-autosuggest-item input="Lorem" text="Loremipsum" subline="Test" image="#" />`,
            ["parser-error"] // <div style="background-image: url("#");"/>
        );
    });
});
